class OTFMainLayout {
    selectorContainer      = '.container, #content';
    selectorBoxedContainer = 'body';
    layoutMode             = 'wide';

    $selectorContainer;

    constructor() {

        this.$selectorContainer = $(this.selectorContainer);
        // this.test();
        this.init();
    }

    init() {
        wp.customize('otf_layout_general_content_width_px', (value) => {
            value.bind((to) => {
                this.setContainerWidth(`${to}px`);
                OSFPreviewSectionHover.getInstance().setPosition();
            });
        });
        wp.customize('otf_layout_general_content_width_percent', (value) => {
            value.bind((to) => {
                this.setContainerWidth(`${to}%`);
                OSFPreviewSectionHover.getInstance().setPosition();
            });
        });

        wp.customize('otf_layout_general_content_width_type', (value) => {
            value.bind((to) => {
                if (to === 'px') {
                    this.setContainerWidth(`${wp.customize('otf_layout_general_content_width_px').get()}px`);
                } else if (to === '%') {
                    this.setContainerWidth(`${wp.customize('otf_layout_general_content_width_percent').get()}%`);
                }
                OSFPreviewSectionHover.getInstance().setPosition();
            });
        });

        wp.customize('otf_layout_general_layout_boxed_width', (value) => {
            value.bind((to) => {
                $(this.selectorBoxedContainer)[0].style.width = `${to}px`;
                OSFPreviewSectionHover.getInstance().setPosition();
            })
        })

        wp.customize('otf_layout_general_layout_mode', (value) => {
            value.bind((to) => {
                if (to == 'boxed') {
                    //console.log($(this.selectorBoxedContainer));
                    $(this.selectorBoxedContainer)[0].style.width = `${wp.customize('otf_layout_general_layout_boxed_width').get()}px`;
                } else {
                    //console.log($(this.selectorBoxedContainer));
                    $(this.selectorBoxedContainer)[0].style.width = '';
                }
                OSFPreviewSectionHover.getInstance().setPosition();
            })
        })
    }

    setContainerWidth(data) {
        this.$selectorContainer.each((index, element) => {
            element.style.width = data;
        })
    }

    test() {
        $(window).load(() => {
            wp.customize.preview.send('preview-move', {
                type: 'section',
                id  : 'otf_layout_general',
            });
        })
    }
}

new OTFMainLayout();